import React from 'react'
import { OfferDetailsType } from './types/ShoppingPageType'
import Logo from './Logo'
import { get } from 'lodash'
import { FptiClick } from './lib/fpti'
import { FormatMessage } from './lib/useWorldReady'
import OfferDetailsModalInfoCard from './OfferDetailsModalInfoCard'
import OfferDetailsModalDisplayCoupon from './OfferDetailsModalDisplayCoupon'
import OfferDetailsModalSavedToWallet from './OfferDetailsModalSavedToWallet'
import { getModalSections } from './HoneyOfferDetailsModal'

export const getModalContent = (
  offerDetails: OfferDetailsType,
  offerType: string,
  fptiClick: FptiClick,
  formatMessage: FormatMessage
) => {
  const {
    title,
    description,
    details,
    termsAndConditionsSection,
    couponCodeSection,
    conditions,
    primaryImage,
    //TODO change decryptedOfferId to encryptedOfferId when graph work is done
    decryptedOfferId: encryptedOfferId,
    savedToWallet
  } = offerDetails
  let howToUseSection = get(offerDetails, 'howToUseSection')
  const sectionsContent = []
  if (offerType === 'sale') {
    howToUseSection = {
      title: 'How to get this deal',
      content: `Shop on the ${title} website. They’ll apply your deal at check out.`
    }
  }

  if (details !== null)
    sectionsContent.push({ content: details, displayShowMore: true })
  if (howToUseSection !== null)
    sectionsContent.push({ content: howToUseSection })
  if (termsAndConditionsSection !== null)
    sectionsContent.push({ content: termsAndConditionsSection })

  const couponStatusDisplay = savedToWallet ? (
    <OfferDetailsModalSavedToWallet encryptedOfferId={encryptedOfferId} />
  ) : (
    <OfferDetailsModalDisplayCoupon
      couponCode={get(couponCodeSection, 'content')}
      fptiEvent={fptiClick}
    />
  )

  return (
    <div id="offerModal" className="offer-details-modal-content">
      <Logo
        className="offer-details-modal-content__image"
        src={primaryImage.url}
        alt={title}
        backgroundColor={primaryImage.backgroundColor}
      />
      <div className="offer-details-modal-content__image__title ppvx_text--body">
        {title}
      </div>
      <OfferDetailsModalInfoCard
        conditions={conditions}
        description={description}
      />
      {offerType === 'coupon' && couponStatusDisplay}
      {getModalSections(sectionsContent, fptiClick, formatMessage)}
    </div>
  )
}
